module.exports = __webpack_public_path__ + "static/img/audio.51bea683.jpg";